import PropTypes from "prop-types";
import React, { createContext, useContext, useMemo } from "react";

import useBOMStateRequired from "../../../hooks/useBOMStateRequired";
import useBom from "../../../hooks/useBom";
import useBomWizardStore from "../../../stores/bomWizardStore";

const FinishedGoodQuestionsContext = createContext();

function FinishedGoodQuestionsContextProvider({ children = "" }) {
  const bomId = useBomWizardStore((s) => s.bomId);
  const { loading: bomLoading, bom } = useBom(bomId);
  useBOMStateRequired(bom?.BOM_State, "FG_QUALIFYING");

  const value = useMemo(() => ({ bomLoading, bom }), [bomLoading, bom]);
  return <FinishedGoodQuestionsContext.Provider value={value}>{children}</FinishedGoodQuestionsContext.Provider>;
}

FinishedGoodQuestionsContextProvider.propTypes = {
  children: PropTypes.node,
};

export { FinishedGoodQuestionsContextProvider };

export function useFinishedGoodQuestionsContext() {
  return useContext(FinishedGoodQuestionsContext);
}
